import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const Accion = ({ accion, paqueteId, seccionId, quitarAccion, costoUbicacion, areaIntervenir, actualizarCosto }) => {
    // Estado para el costo total, empezamos con el valor inicial del costo total
    const [costoTotal, setCostoTotal] = useState(accion.costo_total || "");

    // Estado para manejar si el usuario ha editado el campo
    const [isManual, setIsManual] = useState(false);

    useEffect(() => {
        if (!isManual) {
            // Si el valor es automático, recalculamos el costo
            const costoBase = parseFloat(accion.costo_base) || 0;
            const costoPorUbicacion = parseFloat(costoUbicacion) || 0;
            const metraje = parseFloat(areaIntervenir) || 0;

            let costoCalculado = costoBase;
            if (accion.sujeto_metraje) {
                costoCalculado *= metraje;
            }
            if (accion.sujeto_ubicacion) {
                costoCalculado += costoPorUbicacion;
            }

            // Solo actualizamos si el costo calculado es diferente al costo actual
            if (costoCalculado !== costoTotal) {
                setCostoTotal(costoCalculado); // Actualizamos el costo calculado automáticamente

                // Llamar a actualizarCosto si el costo se calcula automáticamente
                if (actualizarCosto) {
                    actualizarCosto(paqueteId, seccionId, accion.id, costoCalculado);
                }
            }
        }
    }, [accion, areaIntervenir, costoUbicacion, isManual, costoTotal]); // Agregar costoTotal para evitar el bucle infinito


    // Maneja el cambio del valor del input
    const handleCostoChange = (e) => {
        const nuevoCosto = parseFloat(e.target.value) || 0;
        setCostoTotal(nuevoCosto);
        setIsManual(true); // Marcar que el valor ha sido editado manualmente

        if (actualizarCosto) {
            actualizarCosto(paqueteId, seccionId, accion.id, nuevoCosto); // Actualizar el costo en el componente padre
        }
    };

    // useEffect para permitir que el cálculo se actualice cuando cambian areaIntervenir o costoUbicacion
    useEffect(() => {
        if (isManual) {
            // Si el valor fue editado manualmente, restablecemos isManual a false para permitir el cálculo automático
            setIsManual(false);
        }
    }, [areaIntervenir, costoUbicacion]); // Ejecutamos cuando areaIntervenir o costoUbicacion cambian

    return (
        <div className="bg-white border border-gray-200 p-1 rounded-sm flex items-center gap-2 text-sm">
            <button
                onClick={(e) => quitarAccion(e, paqueteId, seccionId, accion.id)}
                className="p-1 bg-transparent hover:bg-red-200 rounded-full text-red-600 hover:text-red-800 focus:outline-none"
                aria-label="Eliminar acción"
            >
                <FaTimes size={12} />
            </button>

            <input
                type="number"
                value={costoTotal}
                onChange={handleCostoChange}  // Llamamos a la función que maneja el cambio de valor
                placeholder="Costo total"
                className="border border-gray-300 rounded-sm p-1 text-sm w-24 focus:ring-1 focus:ring-blue-500 focus:outline-none"
            />
            <h4 className="font-semibold truncate">{accion.accion}</h4>
        </div>
    );
};

export default Accion;
